<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {SmartOfferButtonPlace} from "@/modules/redactor/models/smart-offer/core/SmartOfferButtonPlace";

export default {
  name: "r-smart-offer-button-place",
  props: {
    model: VueTypes.instanceOf(SmartOfferButtonPlace),
    label: VueTypes.string.def("Button Place")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return SmartOfferButtonPlace.getValues();
    }
  }
}
</script>